import React from "react";
import Sidedraw from "./Sidedraw";
import Sidedrawitem from "./Sidedrawitem";
import Tooltip from "@material-ui/core/Tooltip";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import {
  HomeIcon,
  CogIcon,
  QuestionMarkCircleIcon,
  PencilAltIcon,
  AnnotationIcon,
  CalendarIcon,
  AcademicCapIcon,
  BadgeCheckIcon,
  BookOpenIcon,
  BriefcaseIcon,
  PresentationChartLineIcon,
  PuzzleIcon,
} from "@heroicons/react/outline";

const cookies = new Cookies();
function Sidebarcomponent() {
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = "members";
  }
  return (
    <React.Fragment>
      <Sidedraw>
        <Sidedrawitem
          title="Home"
          hidden={user === "members" ? false : true}
          href="/user"
        >
          <Tooltip title="Home" placement="right">
            <HomeIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Home"
          hidden={user === "institue" ? false : true}
          href="/i/institute"
        >
          <Tooltip title="Home" placement="right">
            <HomeIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Education"
          hidden={user === "members" ? false : true}
          href="/education"
        >
          <Tooltip title="Education" placement="right">
            <AcademicCapIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        {/* <Sidedrawitem title="Publication" hidden={user === 'members' ? false : true} href="/publication">
          <Tooltip title="Publication" placement="right">
            <BookOpenIcon className="w-6 text-gray-800"/>
          </Tooltip>
        </Sidedrawitem> */}
        {/* <Sidedrawitem title="Certificates" href="/certificate">
          {user === 'members' ? <Tooltip title="Certificates" placement="right">
            <BadgeCheckIcon className="w-6 text-gray-800"/>
          </Tooltip> : <Tooltip title="Certificates" placement="right"><BadgeCheckIcon className="w-6 text-gray-800"/></Tooltip>}
        </Sidedrawitem> */}
        {/* <Sidedrawitem title="Extra-Curriculum" hidden={user === 'members' ? false : true} href="/extracurriculam">
          <Tooltip title="Extra-Curriculum" placement="right">
            <PuzzleIcon className="w-6 text-gray-800"/>
          </Tooltip>
        </Sidedrawitem> */}
        {/* <Sidedrawitem title="Work Experience" hidden={user === 'members' ? false : true} href="/workexperience">
          <Tooltip title="Work Experience" placement="right">
            <BriefcaseIcon className="w-6 text-gray-800"/>
          </Tooltip>
        </Sidedrawitem> */}
        {/* <Sidedrawitem title="Projects" hidden={user === 'members' ? false : true} href="/project">
          <Tooltip title="Projects" placement="right">
            <PresentationChartLineIcon className="w-6 text-gray-800"/>
          </Tooltip>
        </Sidedrawitem> */}
        {/* <Sidedrawitem hidden={user === 'institue' ? false : true} href="/i/institute/manageusers">
          <Tooltip title="Manage users" placement="right">
            <UsersIcon className="w-6 text-gray-800"/>
          </Tooltip>
        </Sidedrawitem> */}
        <Sidedrawitem
          title="Manage notices"
          hidden={user === "institue" ? false : true}
          href="/i/institute/managenotices"
        >
          <Tooltip title="Manage notices" placement="right">
            {/* <EventNoteIcon style={{ fill: "var(--mintBlack)", fontSize: "30px" }} className="text-3xl" /> */}
            <AnnotationIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Manage events"
          hidden={user === "institue" ? false : true}
          href="/i/institute/events"
        >
          <Tooltip title="Manage events" placement="right">
            {/* <EmojiEventsOutlinedIcon style={{ fill: "var(--mintBlack)", fontSize: "30px" }} className="text-3xl" /> */}
            <CalendarIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem title="Create Blog" href="/createblogs">
          <Tooltip title="Create Blog" placement="right">
            <PencilAltIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Create Question"
          hidden={user === "members" ? false : true}
          href="/createquestions"
        >
          <Tooltip title="Create Question" placement="right">
            <QuestionMarkCircleIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem title="Account settings" href="/account">
          <Tooltip title="Account settings" placement="right">
            <CogIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
      </Sidedraw>
    </React.Fragment>
  );
}

export default Sidebarcomponent;
